// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"LogoutModal_buttonGroup__1Wx6Q","infoText":"LogoutModal_infoText__18MPw"};